var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",staticStyle:{"height":"100vh"}},[(_vm.comeFromOldSystem)?_c('cirdHeader',{attrs:{"history-header":true}}):_c('cird-header-out',{attrs:{"history-header":false}}),_vm._v(" "),_c('router-view',{staticStyle:{"flex-grow":"1"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-7afea74d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/pages/history-index.vue
// module id = zba9
// module chunks = 1